import React from 'react';

import { DIAMETER, NULL_VALUE, NUMBER_REGEX } from '@/common/constants';

const useFeatures = ({ details }) => {
  const getDetails = Object.keys(details).reduce((acc, item) => {
    const { code, displayable, unit, value } = details[item];
    let showUnit = !!unit;

    if (
      typeof value === 'string' &&
      code === DIAMETER &&
      !value.trim().match(NUMBER_REGEX)
    ) {
      showUnit = false;
    }

    if (displayable && value && value !== NULL_VALUE) {
      acc.push({
        ...details[item],
        unit: showUnit ? unit : null,
      });
    }

    return acc;
  }, []);

  const getValue = (detail) => {
    if (['.jpg', '.png'].includes(detail.value)) {
      return (
        <img alt={detail.label} className="list__image" src={detail.value} />
      );
    }

    return <>{`${detail.value}${detail.unit ? ` ${detail.unit}` : ''}`}</>;
  };

  return {
    getDetails,
    getValue,
  };
};

export default useFeatures;
